import { ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { IdleUserSignOutTimerService } from './idle-user/service/idle-user-sign-out-timer.service';
import { OktaAuthStateService } from '@okta/okta-angular';
import { Observable, Subject, map, takeUntil } from 'rxjs';
import { AuthState } from '@okta/okta-auth-js';
import { writeToStorage } from './shared/utils/local-storage.utils';
import { writeToSessionStorage } from './shared/utils/session-storage.utils';
import { instanceIdStorageKey, activeInstanceIdStorageKey } from 'src/app/shared/constants/instance-storage-keys';
import { TabTitleService } from './shared/services/tab-title.service';
import {
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
    Event as RouterEvent
} from '@angular/router';
import { TenantContextService } from './shared/tenant-context/tenant-context.service';

@Component({
    selector: 'cdp-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
    isAuthenticated$: Observable<boolean>;
    idleUserInSeconds = 840; // 14 minutes
    timeoutUserInSeconds = 60; // 60 seconds
    instanceId: string;
    navigating = false;
    private destroy$ = new Subject<boolean>();
    constructor(
        private idleUserSignOutTimerService: IdleUserSignOutTimerService,
        private _oktaAuthStateService: OktaAuthStateService,
        private titleService: TabTitleService,
        private router: Router,
        private tenantContext: TenantContextService,
        private cdr: ChangeDetectorRef
    ) {}

    public get tenantContextReady() {
        return this.tenantContext.tenantContextReady$;
    }

    ngOnInit(): void {
        this.router.events.pipe(takeUntil(this.destroy$)).subscribe(e => {
            this.navigationInterceptor(e);
        });

        this.instanceId = crypto.randomUUID();
        writeToSessionStorage(instanceIdStorageKey, this.instanceId);
        writeToStorage(activeInstanceIdStorageKey, this.instanceId);

        this.idleUserSignOutTimerService.start(this.idleUserInSeconds, this.timeoutUserInSeconds, this.instanceId);
        this.isAuthenticated$ = this._oktaAuthStateService.authState$.pipe(
            map((authState: AuthState) => authState?.isAuthenticated || false)
        );

        this.titleService.setup();
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }

    @HostListener('window:keydown')
    @HostListener('window:mousedown')
    @HostListener('window:mousemove')
    onUserActivity(): void {
        writeToStorage(activeInstanceIdStorageKey, this.instanceId);
    }

    navigationInterceptor(event: RouterEvent): void {
        if (event instanceof NavigationStart) {
            this.navigating = true;
        }
        if (event instanceof NavigationEnd) {
            this.navigating = false;
        }

        // Set loading state to false in both of the below events to hide the spinner in case a request fails
        if (event instanceof NavigationCancel) {
            this.navigating = false;
        }
        if (event instanceof NavigationError) {
            this.navigating = false;
        }
        this.cdr.detectChanges();
    }
}
